import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  {
    // 3
    label: 'What is your:',
    field: 'hrtBMI',
    type: 'info',
    required: false,
    answer: {
      type: 'bmi',
      showLabel: true,
      bmiLabel: 'BMI',
      heightLabel: 'Height',
      weightLabel: 'Weight'
    }
  },
  {
    // 2
    label: 'Any changes in your periods?',
    field: 'hrtPeriods',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes'
        },
        {
          key: 'no',
          value: 'No'
        }
      ]
    }
  },
  {
    // 2-A
    label: 'What are the changes in your Period:',
    field: 'hrtPeriodChanges',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'less', value: 'Less frequent periods' },
        { key: 'lighter', value: 'Lighter periods' },
        { key: 'more', value: 'More frequent periods' },
        { key: 'heavier', value: 'Heavier periods' },
        { key: 'missed', value: 'Missed periods' },
        { key: 'irregular', value: 'Irregular periods' }
      ]
    }
  },
  {
    // 3
    label: 'Are you experiencing any of the following (select all that apply)',
    field: 'hrtexp1',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'hotflashes', value: 'Hot flashes' },
        { key: 'nightsweats', value: 'Night sweats' },
        { key: 'jointPain', value: 'New joint pain or stiffness' },
        {
          key: 'none',
          value: 'None of the above',
          uncheckOthers: true
        }
      ]
    }
  },
  {
    // 4
    label: 'Are you experiencing any of the following (select all that apply)',
    field: 'hrtexp2',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'painDuringSex', value: 'Pain or discomfort during sex' },
        {
          key: 'decreasesex',
          value: 'Decrease in sexual activity and satisfaction'
        },
        { key: 'decreasedesire', value: 'Decrease in sexual desire' },
        { key: 'vaginaldryness', value: 'Vaginal dryness' },
        { key: 'vaginalburn', value: 'Vaginal burning' },
        { key: 'utis', value: 'Recurrent UTIs' },
        {
          key: 'none',
          value: 'None of the above',
          uncheckOthers: true
        }
      ]
    }
  },
  {
    // 5
    label: 'Are you having any symptoms relating to your bladder?',
    field: 'hrtbladder',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'peeMore',
          value:
            'Needing to pee more often or waking up during the night to urinate'
        },
        {
          key: 'leakeage',
          value:
            'Accidental bladder leakage when sneezing, laughing or exercising'
        },
        {
          key: 'intime',
          value: 'Having trouble making it to the bathroom in time'
        },
        { key: 'difficulty', value: 'Difficulty in urinating' },
        {
          key: 'none',
          value: 'None of the above',
          uncheckOthers: true
        }
      ]
    }
  },
  {
    // 6
    label: 'How is your mood lately?',
    field: 'hrtmood',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'ok', value: 'Feeling generally okay and content' },
        { key: 'sad', value: 'Feeling more down or sadder than usual' },
        { key: 'annoyed', value: 'Getting easily frustrated or annoyed' },
        { key: 'stressed', value: 'Feeling stressed out or overwhelmed' },
        { key: 'worried', value: 'Feeling more worried or anxious than usual' },
        { key: 'drive', value: 'Experiencing a lack of drive' },
        { key: 'panicky', value: 'Feeling restless or panicky' },
        { key: 'noChange', value: 'Not noticing any big changes in your mood' }
      ]
    }
  },
  {
    // 8
    label: 'Do any of these conditions apply to you?',
    field: 'hrtconditions',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'cancer',
          value: 'Personal history of breast, endometrial or ovarian cancer'
        },
        { key: 'vagbleeding', value: 'Unexplained vaginal bleeding' },
        {
          key: 'heart',
          value:
            'Heart disease (previous venous thromboembolism, peripheral arterial disease, cardiac event)'
        },
        { key: 'bloodclot', value: 'Blood clot (past or current)' },
        { key: 'stroke', value: 'Stroke history)' },
        { key: 'cloting', value: 'Clotting disorder or thrombophilia' },
        { key: 'liver', value: 'Liver disease or dysfunction' },
        { key: 'pregnancy', value: 'Known or suspected pregnancy' },

        {
          key: 'none',
          value: 'None of the above',
          uncheckOthers: true
        }
      ]
    }
  },
  {
    // 9
    label: 'Do any of these conditions apply to you?',
    field: 'hrtconditions2',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'diabetes', value: 'Diabetes' },
        { key: 'hbp', value: 'High blood pressure' },
        { key: 'cholesterol', value: 'High cholesterol' },
        { key: 'vte', value: 'Elevated risk for VTE' },
        { key: 'smoking', value: 'Smoking' },
        { key: 'obesity', value: 'Obesity' },
        { key: 'malabsorption', value: 'Malabsorption syndrome' },
        { key: 'gallstone', value: 'Gallstones (current or past)' },
        { key: 'migranes', value: 'Migrane with aura' },

        {
          key: 'none',
          value: 'None of the above',
          uncheckOthers: true
        }
      ]
    }
  },
  {
    // 10
    label: 'Have you had a hysterectomy (surgical removal of your uterus)?',
    field: 'hrtHyster',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes'
        },
        {
          key: 'no',
          value: 'No'
        }
      ]
    }
  },
  {
    // 11
    label: 'When was your last menstrual period?',
    field: 'hrtMestrual',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'lessthan1',
          value: 'Less than 1 year ago'
        },
        {
          key: 'morethan1',
          value: 'More than 1 year ago'
        },
        {
          key: 'morethan10',
          value: 'More than 10 years ago'
        }
      ]
    }
  },
  {
    // 12
    label:
      'Do you need birth control? You may need birth control if: you are not sure if you`ve had your final period,are sexually active, you have an intact uterus and ovaries, and/or you do not use any other forms of contraception such as condoms',
    field: 'hrtbc',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'onbc',
          value: 'I am already on birth control'
        },
        {
          key: 'needbc',
          value: 'I need birth control'
        },
        {
          key: 'notsure',
          value: 'I am not sure if I need birth control'
        },
        {
          key: 'donotneed',
          value: 'I do not need birth control'
        }
      ]
    }
  },
  {
    // 14
    label:
      'Preference of therapy: select the options that you would prefer not to take',
    field: 'hrttherapy',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'oralNon', value: 'oral non-hormonal therapy' },
        { key: 'oralHormonal', value: 'oral hormonal therapy' },
        { key: 'topicalgel', value: 'topical gel' },
        { key: 'patch', value: 'topical patch' },
        { key: 'vaginaltab', value: 'vaginal tablet' },
        { key: 'vaginalgel', value: 'vaginal gel' }
      ]
    }
  },
  {
    // 15
    label: 'Please let us know about other concerns that you have',
    field: 'hrtanythingelse',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'weight', value: 'My weight is not where I want it to be' },
        {
          key: 'hair',
          value: 'I have been experiencing some changes in my hair volume'
        },
        { key: 'libido', value: 'I have been struggling with low libido' },
        {
          key: 'supps',
          value:
            'I would be interested in knowing about supplemnets available to help'
        }
      ]
    }
  }
];

export default questionsModels;
